import { gray } from "./sitecolors"

const lblattrs         = 'col-sm-3 col-md-3 col-lg-3 control-label'
const lblattrs1         = 'col-sm-1  control-label'
const lblattrs2         = 'col-sm-2 col-md-2 col-lg-2 control-label'
const lblattrs3        = 'col-sm-3 col-md-3 col-lg-3 control-label'
const lblattrs4        = 'col-sm-4 col-md-4 col-lg-4 control-label'
const lblattrsmed      = 'col-sm-2 col-md-4 col-lg-4 control-label'
const inputattrxsmall  =  'col-sm-4 col-md-4 col-lg-4'
const inputattrxxsmall =  'col-sm-2 col-md-2 col-lg-2'
const inputattr3       =  'col-sm-3 col-md-3 col-lg-3'
const inputattrs4      =  'col-sm-4 col-md-4 col-lg-4'
const lblattrsWide     = 'col-sm-3 col-md-4 col-lg-4 control-label'
const lblattrs5        = 'col-sm-5 col-md-5 col-lg-5 control-label'
const lblattrs6        = 'col-sm-6 col-md-6 col-lg-6 control-label'
const lblattrs7        = 'col-sm-7 col-md-7 col-lg-7 control-label'
const lblattrs8        = 'col-sm-8 col-md-8 col-lg-8 control-label'
const lblattrs9        = 'col-sm-9 col-md-9 col-lg-9 control-label'
const lblattrs10       = 'col-sm-10 col-md-10 col-lg-10 control-label'
const lblattrs11       = 'col-sm-11 col-md-11 col-lg-11 control-label'
const inputattrs       =  'col-sm-8 col-md-8 col-lg-9'
const inputattrs6      =  'col-sm-6 col-md-6 col-lg-6'
const inputattrs5     =  'col-sm-5 col-md-5 col-lg-5'
const inputattrs9     =  'col-sm-9 col-md-9 col-lg-9'
const inputattrs2      =  'col-sm-2 col-md-2 col-lg-2'
const inputattrs1      =  'col-sm-1 col-md-1 col-lg-1'
const inputattrsSmall  =  'col-sm-8 col-md-8 col-lg-8'

const box  = { 
	border:`1px solid ${ gray }`, 
	padding:'15px' , 
	marginRight:'0px', 
	marginBottom:'15px'                    
}
const smallinput = { 
	maxWidth:'40px',
	minHeight:'37px', 
	marginLeft:'3px',
	textAlign:'center', 
	borderRadius:'4px', 
	borderColor:gray, 
	borderWidth:'1px' 
}
const oilfieldoptions = {
  blocks: [5]
} 

export default {
	lblattrs,
	lblattrs1,
	lblattrs2,
	lblattrs3,
	lblattrs4,
	lblattrs5,
	lblattrsmed,
	inputattrxsmall,
	inputattrxxsmall,
	inputattr3,
	lblattrsWide,
	lblattrs6,
	lblattrs7,
	lblattrs8,
	lblattrs9,
	lblattrs10,
	lblattrs11,
	inputattrs,
	inputattrs6,
	inputattrs2,
	inputattrs4,
	inputattrs1,
	inputattrs5,
	inputattrs9,
	inputattrsSmall,
	box,
	oilfieldoptions,
	smallinput
}


// WEBPACK FOOTER //
// ./src/utils/constants/style.js